/**
 * Normalize text for locale-aware substring search (handles pasted JP/EN, quotes, newlines).
 */
export function normalizeForSearch(text) {
  if (text == null || typeof text !== 'string') return ''
  let s = text.trim()
  s = s.replace(/^[\s\u3000「」"'“”‘’]+|[\s\u3000「」"'“”‘’]+$/gu, '')
  s = s.replace(/[\r\n\t]+/g, ' ')
  s = s.replace(/\s+/g, ' ')
  try {
    s = s.normalize('NFKC')
  } catch {
    /* ignore */
  }
  return s.toLowerCase()
}

export function textMatchesQuery(query, ...fields) {
  const haystacks = fields
    .filter((f) => f != null && f !== '')
    .map((f) => normalizeForSearch(String(f)))
  if (!haystacks.length) return false

  const haystackIncludes = (frag) =>
    frag && haystacks.some((h) => h.includes(frag))

  const full = normalizeForSearch(query)
  if (full && haystackIncludes(full)) return true

  const raw = typeof query === 'string' ? query : ''
  const lines = raw.split(/[\r\n]+/).map((s) => s.trim()).filter(Boolean)
  for (const line of lines) {
    const n = normalizeForSearch(line)
    if (n.length >= 1 && haystackIncludes(n)) return true
  }

  const tokens = raw.split(/\s+/).map((s) => normalizeForSearch(s)).filter((s) => s.length >= 2)
  for (const tok of tokens) {
    if (haystackIncludes(tok)) return true
  }
  return false
}
